import {getItemFromStorage} from "./storage"; 
import {getTracker} from "../helpers/tracker";

const selectUserAccess = (selected) => {
  const sellerData = {};

  // Use seller data if available, otherwise fall back to account data
  if (selected?.seller) {
    sellerData.id = selected.seller.id;
    sellerData.display_name = selected.seller.display_name;
  } else if (selected?.account) {
    sellerData.id = selected.account.id;
    sellerData.display_name = selected.account.display_name;
    sellerData.account_type = selected.account.type;
  }

  sellerData.group = selected?.group?.name;
  sellerData.permissions = selected?.group?.permissions;
  getTracker().setMetadata('seller', JSON.stringify(sellerData));
  localStorage.setItem("seller", JSON.stringify(sellerData));
}

const isSubSellerAccess = (access) => {
  const type = (access?.seller || access?.account)?.type;
  return !!type?.includes("SUB");
};

const getUserAccess = () => {
  try {
    const access = getItemFromStorage("seller");
    return JSON.parse(access);
  } catch (e) {
    console.error("Error parsing user access from storage", e);
    return null;
  }
}

const userHasPermission = (permission) => {
  const userAccess = getUserAccess();
  if (!userAccess || !userAccess.permissions) {
    return false;
  }
  if (!permission || permission === "") {
    return true;
  }
  if (permission === "super_user") {
    return isSuperUser();
  }
  for (const perm of userAccess.permissions) {
    if (perm.codename === permission) {
      return true;
    }
  }
  return isSuperUser();
}

const userIsFullyLoggedIn = () => {
  const userAccess = getUserAccess();
  if (!userAccess) {
    return false;
  }
  if (!userAccess.permissions || !Array.isArray(userAccess.permissions)) {
    // user has some access but no permissions, need to re-login
    localStorage.clear();
    sessionStorage.clear();
    return false;
  }
  return userAccess.permissions.length > 0 && userAccess.id;
}

const getUser = () => {
  try {
    const user = getItemFromStorage("userInfo");
    return JSON.parse(user);
  } catch (e) {
    console.error("Error parsing user info from storage", e);
    return null;
  }
}

const isSuperUser = () => {
  const user = getItemFromStorage("userInfo");
  return JSON.parse(user)?.is_superuser;
}

export {isSuperUser, getUser, selectUserAccess, getUserAccess, userHasPermission, userIsFullyLoggedIn, isSubSellerAccess};